module.exports = __webpack_public_path__ + "img/xt.295dc442.png";